export default __webpack_public_path__ + "static/media/banner-xpert3.d270e785.png";